import { NumericRangeFilterOption } from '../types';
import { NumericRange } from '../../components';

export const config: NumericRangeFilterOption = {
  id: 'omicsExplorer.filters.popFreq',
  title: {
    id: 'omicsExplorer.filters.popFreq',
    defaultMessage: 'Pop Freq (gnomAD)',
  },
  content: NumericRange,
  injectedProps: {
    id: 'popAlleleFrequency',
    step: 0.01,
    defaultMaximumValue: 0.1,
    defaultMinimumValue: 0.01,
    searchKey: 'popAlleleFrequency',
    buttonIntlLabel: {
      id: 'omicsExplorer.filters.popFreq.button.placeholder',
      defaultMessage: 'Add Filter',
    },
    maxHelpMessage: {
      id: 'omicsExplorer.filters.popFreq.maxHelpMessage',
      defaultMessage: '<= Max',
    },
    minHelpMessage: {
      id: 'omicsExplorer.filters.popFreq.minHelpMessage',
      defaultMessage: '>= Min',
    },
  },
};
